import React from "react";
import { Table, Space, Button } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  CloseOutlined,
  EyeOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import PermissionRender from "../../../components/PermissionRender";

export const LineTable = ({
  sections,
  loading,
  onEdit,
  onDelete,
  editingEntity,
  onSave,
  onCancel,
  onView,
  isEditing,
}) => {
  const columns = [
    {
      title: "Nom",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Numero",
      dataIndex: "line_number",
      key: "line_number",
    },
    {
      title: "Nombre de places",
      dataIndex: "num_stations",
      key: "num_stations",
    },
    {
      title: "types",
      dataIndex: "types",
      key: "types",
      render: (_, record) => (
        <>
          {record.line_details.length > 0 &&
            record.line_details.map((line) => (
              <div>
                <div>
                  {line.type_line.name} {line.num_stations} places
                </div>
              </div>
            ))}
        </>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          {editingEntity?.id === record.id ? (
            <>
              <Button type="primary" icon={<SaveOutlined />} onClick={onSave}>
                Enregistrer les modifications
              </Button>
              <Button danger icon={<CloseOutlined />} onClick={onCancel}>
                Annuler
              </Button>
            </>
          ) : (
            <>
              <Button
                icon={<EyeOutlined />}
                onClick={() => onView(record)}
                disabled={isEditing}
              ></Button>
              <PermissionRender requiredPermission={["lines", "update"]}>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => onEdit(record)}
                  disabled={isEditing}
                ></Button>
              </PermissionRender>
              {/* <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => onDelete(record.id)}
              ></Button> */}
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={sections}
      rowKey="id"
      loading={loading}
      pagination={{ pageSize: 5 }}
    />
  );
};
